interface CharacterCountHintProps {
  text: string;
}

export function CharacterCountHint({ text }: CharacterCountHintProps) {
  return (
    <div className="text-right justify-start text-neutral-400 text-xs font-normal leading-none">
      {text}
    </div>
  );
}
